import React, {Component} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';

import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import SideNav from '../components/sidenav';
import DefaultContent from '../components/default-content';
import MainContent from '../components/main-content';
import SearchContent from '../components/search-content';
import Login from '../components/login';
import ContentEditor from '../components/admin/editor';
import Profile from '../components/admin/profile';
import NotFound from '../components/not-found';


class AppRouter extends Component {
  constructor(props){
    super(props);
    this.state = {
      isAuthenticated : false,
      userId: ''
    }

    this.checkAuth = this.checkAuth.bind(this);
  }

  componentDidMount(){
    this.checkAuth();
  }

  componentWillReceiveProps(newProps){
    if(this.props === newProps) {return;}
    this.props = newProps;
  }
  
  checkAuth(){
    let apiUrl = `${window.location.protocol}//${window.location.host}/auth/authenticated`;
    fetch(apiUrl)
    .then(res => res.json())
    .then(({isAuthenticated, userProfile}) => {
      this.setState({
        isAuthenticated,
        userId: userProfile
      });
    });
  }

  render(){
    return (
      <BrowserRouter>
        <div className="app-wrapper">
          <Header isAuthenticated={this.state.isAuthenticated} />
          <div className="layout">
            <SideNav isAuthenticated={this.state.isAuthenticated} />
            <div className="help-content">
              <div className="scroller">
                <Switch>
                  <Route exact path="/" component={DefaultContent} />
                  <Route exact path="/search/:product/:term" component={SearchContent} />
                  <Route exact path="/:product/:section/:id" component={MainContent} />
                  <Route exact path="/login" component={Login} />
                  <Route exact path="/admin/editor" component={ContentEditor} />-->
                  <Route exact path="/admin/profile" component={Profile} />
                  <Route component={NotFound} />
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </BrowserRouter>
    );
  }
};

export default AppRouter;